import { render, staticRenderFns } from "./attribute-list.vue?vue&type=template&id=6d0c17d0&"
import script from "./attribute-list.vue?vue&type=script&lang=js&"
export * from "./attribute-list.vue?vue&type=script&lang=js&"
import style0 from "./attribute-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports